import React from 'react'
import { useTranslation } from 'react-i18next'

function Container({ children }) {
  const { t } = useTranslation()

  return (
  <div className="small-12">
    {children || <p>{t('error_no_available_local_page')}</p>}
  </div>
  )
}
export default Container
